import { accountTimezoneCity } from "@data/utility/timezones"
import { elide } from "./activationSuiteDisplay"

/**
 * What to tell the person when the account timezone has moved under them — it
 * follows the device without asking, so it is said after the fact, back to
 * Paris included. Nothing on a first reading, or when the account itself changed
 * (switching to a sibling's profile is not a change of timezone).
 *
 * @param {{userId?: number, timezone?: string} | undefined} previous
 * @param {{userId?: number, timezone?: string, label?: string}} current
 * @returns {string | null}
 */
export const timezoneChangeNotice = (previous, current) => {
    if (
        !previous?.timezone ||
        !current?.timezone ||
        previous.userId !== current.userId ||
        previous.timezone === current.timezone
    ) {
        return null
    }

    return `Tes heures sont maintenant à l'heure ${elide(accountTimezoneCity(current.timezone, current.label), "de")}.`
}
